import { useCallback, useEffect } from 'react';

import { useDomainsStore } from '../../hooks';

import { DomainsTable } from './tables';
import { AdminPanel, UserServersPanel } from './panels';

import { Typography, CircularProgress } from '@mui/material';

export const DomainsStore = () => {
  useEffect(() => {
    document.title = '2leads Dev - Магазин Доменов';
  }, []);

  const { apiKeys, apiType, serverName, userName, isPrimaryAccess, setUserName, setApiType, setServerName } =
    useDomainsStore();

  const getTable = useCallback(() => {
    const tables = {
      facebook: {
        namecheap: <DomainsTable userName={userName} serverName={'namecheap'} />,
      },
      google: {
        netcup: <DomainsTable userName={userName} serverName={'netcup'} />,
        inwx: <DomainsTable userName={userName} serverName={'inwx'} />,
      },
    };

    return (
      tables[apiType]?.[serverName] ?? (
        <Typography variant='h6' color='error'>
          Нет данных
        </Typography>
      )
    );
  }, [apiType, serverName, userName]);

  if (apiKeys.hasKeys === null) {
    return <CircularProgress />;
  }

  return (
    <>
      <Typography variant='h1' fontSize={40} fontWeight={500} gutterBottom>
        Магазин Доменов
      </Typography>

      <UserServersPanel
        apiKeys={apiKeys}
        apiType={apiType}
        serverName={serverName}
        setApiType={setApiType}
        setServerName={setServerName}
      />

      {isPrimaryAccess && <AdminPanel setUserName={setUserName} />}

      {apiKeys.hasKeys ? (
        getTable()
      ) : (
        <Typography variant='h6' color='error'>
          У вас нет серверов
        </Typography>
      )}
    </>
  );
};
